import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74acb2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "Flex_Wrapper" }
const _hoisted_3 = { class: "Flex_Child_Half" }
const _hoisted_4 = { class: "Flex_Child_Half" }
const _hoisted_5 = { class: "Flex_Wrapper" }
const _hoisted_6 = { class: "Flex_Child_Quarter" }
const _hoisted_7 = { class: "Flex_Child_Quarter" }
const _hoisted_8 = { class: "Flex_Child_Quarter" }
const _hoisted_9 = { class: "Flex_Child_Quarter" }
const _hoisted_10 = { class: "Flex_Wrapper" }
const _hoisted_11 = { class: "Flex_Child_Half" }
const _hoisted_12 = { class: "Flex_Child_Half" }

import { useStore } from "vuex";
import searchSelect from "../molecules/searchSelect.vue";
import searchInputText from "../molecules/searchInputText.vue";
import searchInputDate from "../molecules/searchInputDate.vue";
import { ref, watch } from "vue";
import SearchInputCheckbox from "../molecules/searchInputCheckbox.vue";
import SearchInputSyoten from "../molecules/searchInputSyoten.vue";
import common from "../../common";
import SearchInputSyosi from "../molecules/searchInputSyosi.vue";
import { ZaikoData } from "@/types/zaiko";
import SearchInputEvent from "../molecules/searchInputEvent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDaiwari',
  emits: ["onSearch"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();
const emit = __emit;

// 検索項目のリスト-------------------------------------------------
// 進行状態
const progressList = [
  { label: "すべて", value: 0 },
  { label: "進行作品（担当）", value: 3 },
  { label: "進行作品（部署）", value: 4 },
  { label: "台割未確定", value: 1 },
  { label: "原価台帳未確定", value: 2 },
  { label: "確定済", value: 5 },
];
// 部署
const busyoList = [
  { label: "すべて", value: 0 },
  { label: "自部署", value: 1 },
];
//取次(「全件」項目を追加)
const { createToritugiList } = common();
const toritugiList = ref(createToritugiList());

//種別
const syubetuList = store.getters["constant/getSyubetuList"];
//カテゴリ
const categoryList = store.getters["constant/getCategoryList"];
//営業担当者
const salesList = store.getters["constant/getSalesList"];
//在庫ステータス
const zaikoStatusList = store.getters["constant/getZaikoStatusList"];
// ユーザーリスト
const userList = store.getters["constant/getInputUserList"];

// 検索入力値------------------------------------------------------
// 書店検索用
const syotenData = ref({
  bansen: "",
  hanmotoCd: "",
  syotenMei: "",
  toritugiCd: "",
  toritugiSyotenCd: "",
  zassiBansen: "",
});
// 検索項目
const searchConditions = ref({
  progressValue: 0,
  inputText: "aaaa",
  fromDate: "",
  toDate: "2024-02-29",
  inputCheckbox: false,
  syosiCd: "",
  eventMei: "",
  // 書店関連-----------
  bansen: "",
  hanmotoCd: "",
  syotenMei: "",
  toritugiCd: "",
  toritugiSyotenCd: "",
  zassiBansen: "",
  // ------------------
});
watch(searchConditions.value, () => {
  console.log("searchDaiwariのwatch");
  syotenData.value.bansen = searchConditions.value.bansen;
  syotenData.value.hanmotoCd = searchConditions.value.hanmotoCd;
  syotenData.value.syotenMei = searchConditions.value.syotenMei;
  syotenData.value.toritugiCd = searchConditions.value.toritugiCd;
  syotenData.value.toritugiSyotenCd = searchConditions.value.toritugiSyotenCd;
  syotenData.value.zassiBansen = searchConditions.value.zassiBansen;
  console.log(searchConditions.value);
  console.log(syotenData.value);
});
const resetConditions = () => {
  searchConditions.value.progressValue = 0;
  searchConditions.value.inputText = "";
  searchConditions.value.fromDate = "";
  searchConditions.value.toDate = "";
  searchConditions.value.inputCheckbox = false;
  searchConditions.value.syosiCd = "";
  searchConditions.value.eventMei = "";
  searchConditions.value.bansen = "";
  searchConditions.value.hanmotoCd = "";
  searchConditions.value.syotenMei = "";
  searchConditions.value.toritugiCd = "";
  searchConditions.value.toritugiSyotenCd = "";
  searchConditions.value.zassiBansen = "";
};

const changeSyoten = (newSyotenData: typeof syotenData.value) => {
  searchConditions.value.bansen = newSyotenData.bansen;
  searchConditions.value.hanmotoCd = newSyotenData.hanmotoCd;
  searchConditions.value.syotenMei = newSyotenData.syotenMei;
  searchConditions.value.toritugiCd = newSyotenData.toritugiCd;
  searchConditions.value.toritugiSyotenCd = newSyotenData.toritugiSyotenCd;
  searchConditions.value.zassiBansen = newSyotenData.zassiBansen;
};
const changeToritugi = (newVal: string) => {
  console.log("changeToritugi");
  // 新たな取次コードをセットする
  searchConditions.value.toritugiCd = newVal;
  // 取次変更時に書店情報をリセットする
  searchConditions.value.bansen = "";
  searchConditions.value.hanmotoCd = "";
  searchConditions.value.syotenMei = "";
  searchConditions.value.toritugiSyotenCd = "";
  searchConditions.value.zassiBansen = "";
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(searchSelect, {
            initialData: searchConditions.value.progressValue,
            title: '進行状態',
            selectData: progressList,
            onChange: _cache[0] || (_cache[0] = (newVal) => (searchConditions.value.progressValue = newVal))
          }, null, 8, ["initialData"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(searchInputText, {
            initialData: searchConditions.value.inputText,
            title: 'テスト',
            type: 'text',
            onChange: _cache[1] || (_cache[1] = (newVal) => (searchConditions.value.inputText = newVal))
          }, null, 8, ["initialData"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(searchInputDate, {
            title: '日付テスト',
            initialFromData: searchConditions.value.fromDate,
            initialToData: searchConditions.value.toDate,
            onChange: _cache[2] || (_cache[2] = 
              (newFrom, newTo) => (
                (searchConditions.value.fromDate = newFrom),
                (searchConditions.value.toDate = newTo)
              )
            )
          }, null, 8, ["initialFromData", "initialToData"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(SearchInputCheckbox, {
            title: 'チェック',
            initialData: searchConditions.value.inputCheckbox,
            onChange: _cache[3] || (_cache[3] = (newVal) => (searchConditions.value.inputCheckbox = newVal))
          }, null, 8, ["initialData"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SearchInputSyosi, {
            title: '商品コード',
            initialData: searchConditions.value.syosiCd,
            onChange: _cache[4] || (_cache[4] = (newVal) => (searchConditions.value.syosiCd = newVal.syosiCd))
          }, null, 8, ["initialData"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(SearchInputEvent, {
            title: 'イベント',
            initialData: searchConditions.value.eventMei,
            onChange: _cache[5] || (_cache[5] = (newVal) => (searchConditions.value.eventMei = newVal))
          }, null, 8, ["initialData"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(SearchInputSyoten, {
            parentSyotenData: syotenData.value,
            title: '書店',
            onChange: changeSyoten,
            ref: "searchInputSyoten"
          }, null, 8, ["parentSyotenData"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(searchSelect, {
            initialData: searchConditions.value.toritugiCd,
            title: '取次',
            selectData: toritugiList.value,
            onChange: changeToritugi
          }, null, 8, ["initialData", "selectData"])
        ])
      ])
    ])
  ]))
}
}

})